import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, message, Modal, Select } from 'antd';

import ClientVersionSelect from '@lib/components/client-version-select';
import EnvironmentSelect from '@lib/components/env-select';

import { arenaSegmentService } from '@services/cstool';

import { useArenaSegmentContext } from '../context';

type PropsType = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const ForcePlayerModal = (props: PropsType) => {
  const { isOpen, setIsOpen } = props;
  const [form] = Form.useForm();
  const { segmentsData, loadSegmentData } = useArenaSegmentContext();
  const [environment, setEnvironment] = useState<string>();
  const [blueprintVersion, setBlueprintVersion] = useState<string>();

  useEffect(() => {
    loadSegmentData(environment, blueprintVersion);
  }, [environment, blueprintVersion]);

  const closeModal = () => {
    form.resetFields();
    setEnvironment(undefined);
    setBlueprintVersion(undefined);
    setIsOpen(false);
  };

  const handleOk = async () => {
    const formValues = form.getFieldsValue();
    if (!formValues.playerId || !formValues.segment || !formValues.score) {
      message.error('Please fill out all fields completely!!!');
      return;
    }

    await arenaSegmentService.forcePlayer({
      ...formValues,
      blueprintVersion,
      environment,
    });
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  return (
    <Modal title="Force Player" visible={isOpen} onOk={handleOk} onCancel={handleCancel}>
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
        <Form.Item name="environment" label="Environment" required>
          <EnvironmentSelect onChange={setEnvironment} />
        </Form.Item>
        <Form.Item name="blueprintVersion" label="Client Version" required>
          <ClientVersionSelect
            environment={environment}
            disabled={!environment}
            onChange={setBlueprintVersion}
          />
        </Form.Item>
        <Form.Item name="playerId" label="Player ID" required>
          <Input />
        </Form.Item>
        <Form.Item name="segment" label="Segment" required>
          <Select
            disabled={!environment || !blueprintVersion}
            options={(segmentsData ?? [])?.map((segment: any) => ({
              label: segment,
              value: segment,
            }))}
          />
        </Form.Item>
        <Form.Item name="score" label="Score" required>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ForcePlayerModal;
